import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';
import { Page, Section } from '@connected/ui/features/layouts';
import { createFileRoute } from '@tanstack/react-router';
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { DrawingCreateModal, DrawingList } from '@/components/features/drawings';
import { FooterNavigation } from '@/components/navigation/footer-navigation';

export const Route = createFileRoute('/(auth)/projects/$projectVersionId/applications/drawings/')({
    component: DrawingsPage,
    loader: ({ context, params }) => {
        context.queryClient.ensureQueryData(
            elektraAppQueryOptions.project.request.technicalDrawingsQueryOptions({
                electricalProjectVersionId: params.projectVersionId,
            }),
        );
    },
});

export function DrawingsPage() {
    const { t } = useTranslation('applications');

    const params = Route.useParams();
    const search = Route.useSearch();

    return (
        <Page>
            <Section>
                <Section.Header>
                    <Section.Header.Title>{t('drawings.title')}</Section.Header.Title>
                    <Section.Header.Actions>
                        <DrawingCreateModal
                            electricalProjectVersionId={params.projectVersionId}
                            trigger={(
                                <Section.Header.Action
                                    variant="default"
                                    icon={<Plus size={20} />}
                                />
                            )}
                        />
                    </Section.Header.Actions>
                </Section.Header>
                <Section.Content>
                    <DrawingList electricalProjectVersionId={params.projectVersionId} />
                </Section.Content>
                <Section.Footer>
                    <FooterNavigation />
                </Section.Footer>
            </Section>
        </Page>
    );
}
